function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component, Fragment } from 'react';
import classNames from 'classnames';
import { Alert, Space } from '@nackle/paper';
import './alert-list.less';
class AlertList extends Component {
  render() {
    const {
      className,
      title,
      type,
      showIcon,
      alerts,
      section,
      action
    } = this.props;
    if (!Array.isArray(alerts) || alerts.length === 0) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Alert, {
      type: type,
      showIcon: showIcon,
      className: classNames('alert-list', {
        'alert-section': section
      }, className),
      message: /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "alert-title"
      }, title), /*#__PURE__*/React.createElement("ul", {
        className: "message-list"
      }, alerts.map((x, i) => /*#__PURE__*/React.createElement("li", {
        key: i
      }, x.message))), /*#__PURE__*/React.createElement("div", {
        className: "action-container"
      }, /*#__PURE__*/React.createElement(Space, null, action)))
    });
  }
}
_defineProperty(AlertList, "defaultProps", {
  showIcon: true
});
export default AlertList;
//# sourceMappingURL=alert-list.js.map